import React from "react";
import { useTranslation } from "react-i18next";
import LanguageSwitch from "../../../LanguageSwitch/LanguageSwitch";
import "./ProfileModal.css";
import ThemeToggle from "../../../UI/ThemeToggle/ThemeToggle";
import RiseModal from "../../../RiseModal/RiseModal";
import { Link } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { IoLogOutOutline, IoSettings } from "react-icons/io5";
import { MdOutlineGTranslate } from "react-icons/md";
import { useSelector } from "react-redux";
import { useLogout } from "../../../../hooks/useLogout";

const AdminProfileModal = ({ onClose, style }) => {
  const user = useSelector((state) => state.user);
  const { t } = useTranslation(["nav", "common"]);
  const { logout: handleLogout, loggingOut } = useLogout();

  return (
    <RiseModal style={style} onClose={onClose}>
      <div className="profile_modal">
        <div className="profile_modal_title">
          {t("nav:welcome", { name: user.firstname || "" })}
        </div>
        <div className="profile_modal_item">
          <MdOutlineGTranslate size={20} className="profile_modal_icon" />
          <div className="flex-1">{t("common:language.label")}</div>
          <LanguageSwitch />
        </div>
        <Link
          className="profile_modal_item"
          to={"admin/settings/table-pagination"}
        >
          <IoSettings size={20} className="profile_modal_icon" />
          <div>{t("nav:settings")}</div>
        </Link>
        <hr />
        <div className="flex items-center justify-between gap-2 px-[15px] py-[7px] text-[8px] text-ui-text-muted select-none">
          <span>{t("common:theme.label")}</span>
          <ThemeToggle compact />
        </div>
        <hr />
        <div
          className={`profile_modal_item ${
            loggingOut && "profile_modal_itemdisabled"
          }`}
          f
          onClick={handleLogout}
        >
          <IoLogOutOutline size={20} className="profile_modal_icon" />
          <div>{t("common:actions.logout")}</div>
          {!loggingOut && (
            <div className="version__badge">
              {process.env.React_APP_Version}
              <span></span>
            </div>
          )}
          <span className="pm_item_logoutloader">
            {" "}
            {loggingOut && <CircularProgress size={16} />}
          </span>
        </div>
      </div>
    </RiseModal>
  );
};

export default AdminProfileModal;
